import { Company, Contact } from "../../../types/dataModels";
import { Filter, StandardAxiosConfig, USER_NOT_FOUND, USER_NOT_LINKED } from "../../../common";
import { DataAPI_Base, GetAPI_Base, UpdateAPI_Base } from "../base";
import axios from "axios";
import { UserSettings } from "../../../../utilities/types";

class GetAPI_Contacts extends GetAPI_Base<Contact> {
	constructor() {
		super("contacts");
	}

	override async byId(id: string): Promise<Contact> {
		const contact = await super.byId(id);

		if (!contact.id) {
			throw new Error(USER_NOT_FOUND);
		} else if (contact.companyIdsAll.length === 0) {
			throw new Error(USER_NOT_LINKED);
		}

		return contact;
	}

	async byCompany(company: Company): Promise<Contact[]> {
		const filter: Filter<Contact> = {
			fields: [{ companyIds: [company.name] }],
		};
		return this.byFilter(filter);
	}
}

class UpdateAPI_Contacts extends UpdateAPI_Base<Contact> {
	constructor() {
		super("contacts");
	}

	public async portalSettings(id: string, value: UserSettings) {
		const url = `${this.baseUrl}/${id}/portal-settings`;
		await axios.post(url, value, StandardAxiosConfig());
	}
}

export class ContactsAPI extends DataAPI_Base<Contact> {
	get: GetAPI_Contacts;
	update: UpdateAPI_Contacts;

	constructor() {
		super("contacts");
		this.get = new GetAPI_Contacts();
		this.update = new UpdateAPI_Contacts();
	}
}
